import React from 'react';
import { Form, Container } from 'react-bootstrap';

const normalizeDateValue = value => {
  if (!value) {
    return value;
  }

  const [year, month, day] = value.split('-');
  const normalizedYear = (year || '').slice(0, 4);

  return [normalizedYear, month, day].filter(Boolean).join('-');
};

const getTodayDateString = () => new Date().toISOString().slice(0, 10);

const getAgeInYears = value => {
  if (!value) {
    return null;
  }

  const [year, month, day] = value.split('-').map(part => parseInt(part, 10));
  if (!year || !month || !day) {
    return null;
  }

  const today = new Date();
  const birthDate = new Date(year, month - 1, day);

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1;
  }

  return age;
};

const isOutsideAgeRange = (value, minYears, maxYears) => {
  const age = getAgeInYears(value);
  if (age === null) {
    return false;
  }

  return age < minYears || age > maxYears;
};

function DateField({ title, selected, onChange }) {
  const normalizedSelected = normalizeDateValue(selected || '');
  const maxDate = getTodayDateString();

  const handleChange = event => {
    const normalizedValue = normalizeDateValue(event.target.value);

    if (normalizedValue !== event.target.value) {
      event.target.value = normalizedValue;
    }

    onChange(normalizedValue);
  };

  const handleBlur = event => {
    const normalizedValue = normalizeDateValue(event.target.value);

    if (normalizedValue && isOutsideAgeRange(normalizedValue, 18, 60)) {
      event.target.value = '';
      onChange('');
    }
  };

  return (
    <Container className="question-field">
      <h5 className="question-field__title">{title}</h5>
      <Form.Control
        type="date"
        className="question-field__input"
        value={normalizedSelected}
        onChange={handleChange}
        onBlur={handleBlur}
        max={maxDate}
      />
    </Container>
  );
}

export default DateField;
